module.exports = __webpack_public_path__ + "img/about_6.a6091b6e.jpg";